import {FC} from 'react'
import {User, UserFranchise} from '../../core/_models'
import {TooltipWrapper} from '../../../../../components/Tooltip'

type Props = {
  user: User
}

// Usuários vinculados a muitas franquias poluem a grid: exibe só as primeiras e agrupa o resto em "+N"
const MAX_VISIBLE = 3

const isActive = (franchise: UserFranchise) => franchise.userFranchise?.active !== false

const FranchisesCell: FC<Props> = ({user}) => {
  if (!user.franchises?.length) return <span className='text-muted'>-</span>

  // Vínculos ativos primeiro, depois ordem alfabética
  const franchises = [...user.franchises].sort(
    (a, b) => Number(isActive(b)) - Number(isActive(a)) || a.name.localeCompare(b.name)
  )
  const visible = franchises.slice(0, MAX_VISIBLE)
  const hidden = franchises.slice(MAX_VISIBLE)

  return (
    <div className='d-flex flex-wrap gap-1 mw-250px'>
      {visible.map((franchise) => (
        <span
          key={franchise.id}
          className={`badge fs-8 ${isActive(franchise) ? 'badge-light-success' : 'badge-light text-muted'}`}
          title={isActive(franchise) ? 'Vínculo ativo' : 'Vínculo inativo'}
        >
          {franchise.name}
        </span>
      ))}
      {hidden.length > 0 && (
        <TooltipWrapper
          tooltipText={hidden
            .map((franchise) => (isActive(franchise) ? franchise.name : `${franchise.name} (inativo)`))
            .join(', ')}
          tooltipPlacement='top'
        >
          <span className='badge fs-8 badge-light-primary'>+{hidden.length}</span>
        </TooltipWrapper>
      )}
    </div>
  )
}

export {FranchisesCell}
